import { delayedPromise } from '@anecdotes/utils';
import { Directive, ElementRef, HostListener, Input, OnChanges, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[ellipsisWithCount]',
  exportAs: 'ellipsisWithCount',
})
export class EllipsisWithCountDirective implements OnChanges {
  @Input()
  items: string[] = [];

  @Input()
  expectedSymbolWidth = 10;

  isOverflown: boolean;

  hiddenItems: string[];

  constructor(private element: ElementRef) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.doArraysHaveSameValues(changes?.items?.previousValue || [], changes?.items?.currentValue || [])) {
      this.adjustItemsDisplay();
    }
  }

  private async adjustItemsDisplay(): Promise<void> {
    // This is a workaround as we have to delay the initialization
    await delayedPromise(0);

    let totalWidth = 0;
    let visibleItems: string[] = [];
    let hiddenItems: string[] = [];
    let hiddenItemsCount = 0;

    for (const item of this.items) {
      const estimatedItemWidth = item.length * this.expectedSymbolWidth;
      if (totalWidth + estimatedItemWidth <= this.element.nativeElement.offsetWidth) {
        totalWidth += estimatedItemWidth;
        visibleItems.push(item);
      } else {
        hiddenItemsCount++;
        hiddenItems.push(item);
      }
    }

    if (hiddenItemsCount > 0) {
      this.element.nativeElement.textContent = visibleItems.join(', ') + `, +${hiddenItemsCount}...`;
      this.hiddenItems = hiddenItems;
      this.isOverflown = true;
    } else {
      this.element.nativeElement.textContent = visibleItems.join(', ');
    }
  }

  private doArraysHaveSameValues<T>(firstArray: T[], secondArray: T[]): boolean {
    if (firstArray.length !== secondArray.length) {
      return false;
    } else {
      const firstSortedArrayWithoutDuplicates = [...new Set(firstArray)].sort();
      const secondSortedArrayWithoutDuplicates = [...new Set(secondArray)].sort();

      for (let i = 0; i < firstSortedArrayWithoutDuplicates.length; i++) {
        if (firstSortedArrayWithoutDuplicates[i] !== secondSortedArrayWithoutDuplicates[i]) {
          return false;
        }
      }

      return true;
    }
  }

  @HostListener('window:resize')
  private onResize(): void {
    this.adjustItemsDisplay();
  }
}
